export default "__VITE_ASSET__DQjtFvE5__"